module.exports = __webpack_public_path__ + "static/img/grid-ptips-general.e85da68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid-ptips-general.jpg
// module id = 150
// module chunks = 0